import { render, staticRenderFns } from "./abnormalCharacteristics.vue?vue&type=template&id=7dc248c9&scoped=true"
import script from "./abnormalCharacteristics.vue?vue&type=script&lang=js"
export * from "./abnormalCharacteristics.vue?vue&type=script&lang=js"
import style0 from "./abnormalCharacteristics.vue?vue&type=style&index=0&id=7dc248c9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc248c9",
  null
  
)

export default component.exports